/** Tenant-wide compliance settings writers; facility overrides have their own scope. */
export const COMPLIANCE_SETTINGS_WRITE_ROLES = [
  'SYSTEM_ADMIN',
  'TENANT_ADMIN',
  'QUALITY_DIRECTOR',
  'QUALITY_OFFICER',
  'COMPLIANCE_OFFICER',
] as const;

export function canWriteComplianceSettings(role: string | null | undefined): boolean {
  return Boolean(role && (COMPLIANCE_SETTINGS_WRITE_ROLES as readonly string[]).includes(role));
}
